import { QueryEntity, EntityActions } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { KanbanBoardStore, KanbanBoardState } from './kanban-board.store';


@Injectable({
    providedIn: 'root'
})
export class KanbanBoardQuery extends QueryEntity<KanbanBoardState> {
    activeColumn = this.select(state => state.ui.activeColumn);
    newProject$ = this.select(state => state.newProject);
    filter$ = this.select(state => state.ui.filter);
    columnsIdsToShow$ = this.select(state => state.ui.columnsIdsToShow);
    updateBoard$ = this.select(state => state.ui.updateBoard);

    constructor(protected store: KanbanBoardStore) {
        super(store);
    }
}